/**
 * The classroom-local calendar date as `YYYY-MM-DD`.
 *
 * The kiosk's local clock defines the school day — the same definition the
 * planner and weather already use. Always derive "today" from this (never from
 * a UTC ISO string, which can roll a day early/late depending on timezone).
 */
export function isoDate(d: Date = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
    d.getDate(),
  ).padStart(2, '0')}`;
}
